export const initialState = {
  filters: {},
  questionnaires: [],
  questionnaire: {},
  questionnaireBySlug: {},
  editTranslation: {},
  loading: false
};
